export class Code {
    id: number;
    code: string;
    tableName: string;
}
